import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getNotificationUsers, sendNotification } from '../../Services/ApiServices';
import { IMG_URL } from '../../Services/Api';
import placeholderImg from "../../Assets/Image/admin/placeholder.jpg";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import toast from 'react-hot-toast';
import { Circles } from 'react-loader-spinner';

const Notification = () => {
  const [userOptions, setUserOptions] = useState([]);

  useEffect(() => {
    getNotificationUsers()
      .then((data) => {
        const formattedUsers = data.data.data.map(user => ({
          label: `${user.firstname} ${user.lastname}`,
          value: user.id,
          profile: user.profile_image,
        }));
        setUserOptions(formattedUsers);
      })
      .catch((error) => {
        console.error('Error fetching users:', error);
      });
  }, []);

  const validationSchema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    description: Yup.string().required('Description is required'),
    selectedUsers: Yup.array().when("selectAll", {
      is: false,
      then: (schema) => schema.min(1, "Please select at least one user"),
    }),
  });

  const handleNotificationSend = (values, { setSubmitting, resetForm }) => {

    const userIds = values.selectAll
      ? ["0"]
      : values.selectedUsers.map(user => user.value.toString());

    const payload = {
      userIds: userIds.join(","),
      title: values.title,
      body: values.description,
    };

    sendNotification(payload)
      .then(response => {
        toast.success(response?.data?.message);
        resetForm();
      })
      .catch(error => {
        console.error("Error sending notification:", error);
        toast.error(error?.response?.data?.message);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className='md:m-4 m-1 fontNew'>
      <div className='bg-white rounded-xl p-5 xl:w-[60%] w-full'>
        <Formik
          initialValues={{ title: "", description: "", selectedUsers: [], selectAll: false }}
          validationSchema={validationSchema}
          onSubmit={handleNotificationSend}
        >
          {({ values, errors, touched, setFieldValue, isSubmitting }) => (
            <Form>
              <div className='mb-3'>
                <label className='text-sm'>Title :</label>
                <Field
                  type='text'
                  name='title'
                  placeholder='Enter title'
                  className={`bg-transparent px-4 rounded-xl border-2 h-12 w-full outline-secondary text-base mt-2 ${errors.title && touched.title ? "border-red-500" : "border-slate-300"
                    }`}
                />
                <ErrorMessage name="title" component="div" className="text-red-500 text-sm mt-1" />
              </div>

              <div className='mb-3'>
                <label className='text-sm'>Description :</label>
                <Field
                  as="textarea"
                  name='description'
                  rows={4}
                  placeholder='Enter description'
                  className={`bg-transparent px-4 rounded-xl border-2 w-full outline-secondary pt-2 text-base mt-2 ${errors.description && touched.description ? "border-red-500" : "border-slate-300"
                    }`}
                />
                <ErrorMessage name="description" component="div" className="text-red-500 text-sm mt-1" />
              </div>

              <div>
                <label className='text-sm'>Send to :</label>
                <div className='sm:flex items-center w-full'>
                  <div className='mt-2 flex w-[150px] items-center gap-2'>
                    <Field
                      type='checkbox'
                      name='selectAll'
                      className='border-2 border-[#F9F9F9] w-4 h-4'
                      checked={values.selectAll}
                      onChange={(e) => {
                        setFieldValue("selectAll", e.target.checked);
                        setFieldValue("selectedUsers", e.target.checked ? [{ label: "All Users", value: 0 }] : []);
                      }}
                    />
                    <label className='text-sm'>All Users</label>
                  </div>

                  <div className='sm:mt-0 w-full mt-3'>
                    <Select
                      isMulti
                      name="selectedUsers"
                      options={userOptions}
                      value={values.selectedUsers}
                      onChange={(selected) => setFieldValue("selectedUsers", selected)}
                      getOptionLabel={(e) => (
                        <div className="flex items-center">
                          <img
                            src={e.profile ? IMG_URL + e.profile : placeholderImg}
                            alt="User Profile"
                            className="w-5 h-5 rounded-full mr-2"
                          />
                          {e.label}
                        </div>
                      )}
                      getOptionValue={(e) => e.value}
                      filterOption={(option, inputValue) => {
                        if (!option.data || !option.data.label) return false;
                        
                        const label = String(option.data.label).toLowerCase();
                        return label.includes(inputValue.toLowerCase());
                      }}                      
                      isDisabled={values.selectAll}
                      className="basic-multi-select outline-none focus:ring-0 focus:outline-secondary w-full"
                      classNamePrefix="select"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          boxShadow: "none",
                          borderColor: state.isFocused ? "green" : provided.borderColor,
                          "&:hover": {
                            borderColor: provided.borderColor,
                          },
                          backgroundColor: values.selectAll ? "#f3f3f3" : "white",
                          cursor: values.selectAll ? "not-allowed" : "default",
                        }),
                      }}
                    />
                    <ErrorMessage name="selectedUsers" component="div" className="text-red-500 text-sm mt-1" />
                  </div>
                </div>
              </div>

              <div className='border border-[#F9F9F9] mt-6 mb-4'></div>

              <div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-primary h-[50px] disabled:bg-red-400 sm:w-36 w-34 text-sm rounded-xl text-white"
                >
                  {isSubmitting ?
                    <div className="flex justify-center">
                      <Circles width={25} height={25} color="#fff" ariaLabel="circles-loading" />
                    </div> : "Push Notification"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Notification;
